import * as React from "react";
import {
  Text,
  TextInput,
  View,
  StyleSheet,
  Image,
  TouchableWithoutFeedback,
  TouchableOpacity,
} from "react-native";

import { useNavigation } from "@react-navigation/native";
import { modifyPartner } from "../redux/actions/PartnerActions";
import GlobalStyles from "../components/GlobalStyles";
import axios from "axios";
import { useSelector } from "react-redux";
import { submit_linking } from "../redux/actions/UserActions";
import {
  user_logout,
  start_linking,
  end_linking,
} from "../redux/actions/UserActions";
import { Auth } from "aws-amplify";

async function LogoutButton({ navigation }) {
  const userAttributes = useSelector((state) => state.user.user.attributes);
  const u = await Auth.currentAuthenticatedUser();
  const r = await Auth.updateUserAttributes(u, {
    "custom:auraNumber": "linking",
  });

  start_linking(userAttributes.sub);

  Auth.signOut().then(() => {
    user_logout();
    navigation.navigate("Welcome");
  });
}

async function SubmitLinking({ navigation }) {
  submit_linking();
  navigation.replace("MainMenu");
}

async function CancelLinking(navigation) {
  end_linking();
  navigation.replace("MainMenu");
}

export default function LinkingConfirmationScreen({ route }) {
  const navigation = useNavigation();
  const linkingMode = useSelector((state) => state.user.linkingMode);

  React.useEffect(() => {
    if (!linkingMode) {
      navigation.replace("MainMenu");
    }
  }, [linkingMode]);

  return (
    <View style={GlobalStyles.containerMB}>
      <View style={styles.bodyContainerT}>
        <View style={styles.formContainer}>
          <Text style={styles.textStyleHeaderB}>Joining your accounts</Text>
          <Text style={styles.TextStyleBody}>
            Your merge request is pending. Within 15 seconds we'll be able to a
            link this account's details to your new one.
          </Text>
          <View style={styles.formStyle}>
            <View style={styles.buttonContainer}>
              <TouchableOpacity
                style={styles.SubmitButtonStyleContinue}
                activeOpacity={0.5}
                onPress={() => SubmitLinking(navigation)}
              >
                <Text style={styles.textStyleButton}> Let's do it</Text>
              </TouchableOpacity>
              <TouchableOpacity
                style={styles.SubmitButtonStyleCancel}
                activeOpacity={0.5}
                onPress={() => CancelLinking(navigation)}
              >
                <Text style={styles.textStyleButton}>No thanks</Text>
              </TouchableOpacity>
            </View>
          </View>
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  bodyContainerT: {
    flex: 1,
    paddingTop: 30,
    paddingLeft: 30,
    paddingRight: 30,
    paddingBottom: 30,
    justifyContent: "center",
  },

  formStyle: {
    flex: 1,
    flexDirection: "column",
    width: "90%",
  },

  buttonContainer: {
    //flexDirection: "column",
    width: "100%",
    //alignContent: "flex-start",
    paddingLeft: 0,
    paddingRight: 10,
    paddingTop: 10,
    paddingBottom: 10,
  },

  textStyleButton: {
    color: "#000",
    textAlign: "center",
    fontFamily: "montserrat-medium",
    fontSize: 14,
    lineHeight: 14,
    //backgroundColor: "green"
  },

  TextStyle: {
    color: "#000000",
    textAlign: "center",
    fontFamily: "montserrat-medium",
    fontSize: 14,
    lineHeight: 14,
  },

  textStyleHeaderB: {
    color: "#ffffff",
    textAlign: "left",
    fontFamily: "montserrat-bold",
    fontSize: 22,
    width: "100%",
    paddingLeft: 30,
    paddingRight: 30,
  },

  TextStyleBody: {
    color: "#000000",
    textAlign: "left",
    fontFamily: "montserrat-regular",
    fontSize: 14,
    paddingLeft: 30,
    paddingRight: 30,
    paddingBottom: 20,
    paddingTop: 10,
  },
  formContainer: {
    alignContent: "center",
    backgroundColor: "#FFC72C",
    width: "100%",
    alignItems: "center",
    justifyContent: "center",
    paddingTop: 55,
    borderTopLeftRadius: 70,
    borderTopRightRadius: 70,
    borderBottomRightRadius: 70,
    paddingBottom: 55,
    minHeight: 475,
    maxWidth: 800,
    alignSelf: "center",
    paddingLeft: 15,
    paddingRight: 15,
  },

  SubmitButtonStyleContinue: {
    //paddingTop: 20,
    // paddingBottom: 25,
    borderRadius: 50,
    marginLeft: 10,
    backgroundColor: "#FFFFFF",
    flex: 1,
    color: "#000000",
    height: 60,
    maxHeight: 60,
    minHeight: 60,
    justifyContent: "center",
    marginBottom: 20,
  },

  SubmitButtonStyleCancel: {
    //paddingTop: 20,
    // paddingBottom: 25,
    borderRadius: 50,
    marginLeft: 10,
    backgroundColor: "#FFC72C",
    flex: 1,
    color: "#000000",
    height: 60,
    maxHeight: 60,
    minHeight: 60,
    justifyContent: "center",
    marginBottom: 20,
    borderEndColor: "#000000",
    borderStyle: "solid",
    borderWidth: 1,
  },
});
